/* ballstories Konfigurator — Modal-Steuerung
 *
 * Öffnet/schließt den Wizard in einem nativen <dialog> (display_mode = "modal").
 * Das native <dialog> liefert Fokus-Trap und ESC-zum-Schließen out of the box;
 * hier kommen nur Trigger-/Close-/Backdrop-Klicks und der Body-Scroll-Lock dazu.
 *
 * Mehrere Blöcke pro Seite werden unterstützt: jede [data-bs-app]-Instanz hat
 * ihren eigenen Trigger + Dialog und wird unabhängig verdrahtet.
 */
(function () {
  "use strict";

  var BODY_LOCK_CLASS = "bs-modal-open";

  function lockScroll() {
    document.documentElement.classList.add(BODY_LOCK_CLASS);
  }
  function unlockScroll() {
    // Nur entsperren, wenn kein anderer Dialog mehr offen ist.
    if (!document.querySelector("dialog.bs-modal[open]")) {
      document.documentElement.classList.remove(BODY_LOCK_CLASS);
    }
  }

  function wire(app) {
    if (app.__bsModalWired) return;
    app.__bsModalWired = true;

    var dialog = app.querySelector("[data-bs-modal]");
    var openBtn = app.querySelector("[data-bs-open]");
    var closeBtn = app.querySelector("[data-bs-close]");
    var inner = app.querySelector("[data-bs-modal-inner]");
    if (!dialog || !openBtn) return;

    // Android-15-Edge-to-Edge-Fix: Das Top-Layer-<dialog> füllt dort per CSS
    // (inset:0 / dvh) die Fläche nicht zuverlässig -> unten scheint die Seite durch.
    // Deshalb Höhe UND Breite beim Öffnen hart per visualViewport setzen und bei
    // Viewport-Änderungen (Toolbar/Gestenleiste/Tastatur) nachziehen. Nur mobil.
    //
    // Breite ist wichtig: Beim Aufklappen der Android-Tastatur meldet der Layout-
    // Viewport (inset:0-Box) kurzzeitig einen falschen/schmaleren Wert, bevor er
    // sich auf die reale Breite einpendelt. Ohne expliziten width-Fix wird der
    // Dialog dadurch kurz schmaler und der halbtransparente ::backdrop scheint an
    // den Seiten durch ("Konfigurator wird schmal und leicht transparent").
    // visualViewport.width bleibt beim Tastatur-Ein-/Ausblenden stabil (nur die
    // Höhe ändert sich), daher ist es die verlässlichere Quelle als CSS vw/auto.
    var vv = window.visualViewport;
    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }
    function applySize() {
      if (!dialog.open || !isMobile()) return;
      var h = (vv && vv.height) || window.innerHeight;
      var w = (vv && vv.width) || window.innerWidth;
      dialog.style.setProperty("width", w + "px", "important");
      dialog.style.setProperty("max-width", w + "px", "important");
      dialog.style.setProperty("height", h + "px", "important");
      dialog.style.setProperty("max-height", h + "px", "important");
    }
    function clearSize() {
      dialog.style.removeProperty("width");
      dialog.style.removeProperty("max-width");
      dialog.style.removeProperty("height");
      dialog.style.removeProperty("max-height");
    }

    function open() {
      // showModal() ist nötig für Fokus-Trap + ::backdrop. Fallback: open-Attribut.
      if (typeof dialog.showModal === "function") {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }

      // Mobile-Fokus-Race-Fix: Ohne explizites [autofocus] soll laut Spec der
      // <dialog> selbst den Fokus erhalten. Manche mobile Browser fokussieren
      // aber trotzdem automatisch das erste fokussierbare Feld (hier: Vorname) —
      // das startet Tastatur/Zoom bereits VOR dem ersten echten Nutzer-Tap,
      // während applySize() den Viewport noch im alten (Tastatur-losen) Zustand
      // misst. Landet der erste echte Tap zufällig auf demselben, bereits
      // auto-fokussierten Feld, entsteht dadurch kein neuer Fokus-Zyklus und der
      // Race-Zustand (Dialog wirkt schmal + ::backdrop scheint durch) bleibt
      // sichtbar, bis ein Fokuswechsel auf ein ANDERES Feld ihn aufräumt.
      // Fix: ein evtl. automatisch fokussiertes Feld sofort wieder blur()en,
      // damit garantiert JEDER Fokuswechsel im Dialog ein frischer, sauberer
      // Zyklus ist — unabhängig davon, welches Feld zuerst angetippt wird.
      if (document.activeElement && document.activeElement !== dialog && dialog.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      lockScroll();
      applySize();
      // Nachziehen einen Frame spaeter: falls der erste Blur/showModal-Zyklus
      // (oben) selbst noch eine Tastatur-Animation angestossen hat, bevor
      // applySize() gemessen hat, korrigiert dieser zweite Durchlauf auf den
      // dann bereits fokuslosen, stabilen Viewport.
      requestAnimationFrame(applySize);
      if (vv) {
        vv.addEventListener("resize", applySize);
        vv.addEventListener("scroll", applySize);
      }
    }

    function close() {
      if (typeof dialog.close === "function") {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute("open");
      }
      if (vv) {
        vv.removeEventListener("resize", applySize);
        vv.removeEventListener("scroll", applySize);
      }
      clearSize();
      unlockScroll();
    }

    openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);

    // Backdrop-Klick: Klick direkt auf <dialog> (außerhalb des Inhalts) schließt.
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) close();
    });
    // Inhalt-Klicks nicht zum Dialog durchreichen (sonst schließt der erste Klick).
    if (inner) {
      inner.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }

    // ESC feuert das native "cancel"-Event -> Scroll-Lock konsistent aufheben.
    dialog.addEventListener("cancel", function () {
      unlockScroll();
    });
    dialog.addEventListener("close", function () {
      unlockScroll();
    });
  }

  function boot() {
    document.querySelectorAll('[data-bs-app][data-display-mode="modal"]').forEach(wire);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
